export const ALERT_MANAGER_TOKEN = Symbol('IAlertManager');

export interface IAlertManager {
  show(params: {
    title?: string;
    text: string;
    closeButton?: string;
    reloadApp?: boolean;
  }): Promise<void>;
  showConnectionError(): Promise<void>;
  showUnhandled(): Promise<void>;
  showSessionExpired(): Promise<void>;
}
